<template>
    <div>

        <div class="uk-grid uk-grid-large" uk-grid>

            <div class="uk-width-1-1 uk-width-1-3@m uk-width-1-4@l">
                <div class="dr-events-sidebar">
                    <dr-date-picker/>
                    <div class="uk-margin-medium-bottom@m">
                        <dr-checkbox-group/>
                    </div>
                </div>
            </div>

            <div class="uk-width-expand dr-events-main">
                <div class="dr-events-main-wrapper">
                    <dr-active-filter/>
                    <dr-event-list/>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import CheckboxGroup from './filter/Checkbox-group.vue'
    import ActiveFilter from './filter/Active-filter.vue'
    import EventList from './events/Event-list.vue'
    import DatePicker from './shared/DatePicker.vue'
    import store from "../store/store";

    export default {
        name: "Index",
        components: {
            'dr-checkbox-group': CheckboxGroup,
            'dr-active-filter': ActiveFilter,
            'dr-event-list' : EventList,
            'dr-date-picker' : DatePicker
        },
        beforeCreate() {
            this.$store.dispatch('getData');
        },
        beforeRouteUpdate(to, from, next) {
            store.dispatch('loadQueryParams', to.query);
            next();
        }
    }
</script>


<style lang="scss">
   @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";

    .dr-events-sidebar {
		position: sticky;
		top: 100px;
		background-color: #fff;
		border-radius: 6px;
		padding: 16px;
	}

	.dr-events-main {
		@media (min-width: 1200px) {
			padding-left: 40px !important;
		}

		&-wrapper {
			background-color: #fff;
			border-radius: 6px;
			padding: 30px 24px;

			@include min(m) {
				padding: 52px 40px;
			}

			@include min(l) {
				padding: 64px 64px;
			}
		}
	}

</style>
